import React, { FC, useMemo } from 'react';
import IconDS22 from 'src/common/components/IconDS22';
import s from './FieldWrapper.module.scss';

type Props = {
  error: string;
  errorClassName?: string;
  warning: string;
  touched: boolean;
  warningClassName?: string;
  shouldBeTouchedToShowError?: boolean;
  withIcon?: boolean;
};

const AlertMessage: FC<Props> = ({
  touched,
  error,
  warning,
  errorClassName = s.error,
  warningClassName = s.warning,
  shouldBeTouchedToShowError = true,
  withIcon = false,
}) => {
  const element = useMemo(() => (
    <div
      className={error ? errorClassName : warningClassName}
    >
      {withIcon && error && (
        <IconDS22
          className={s.icon}
          id="warning-filled"
          size="s"
        />
      )}
      {error || warning}
    </div>
  ), [error, errorClassName, warning, warningClassName, withIcon]);

  if (shouldBeTouchedToShowError) {
    return touched ? element : null;
  }
  return element;
};

export default AlertMessage;
